<template>
  <div>
    <el-table
      :data="files"
    >
      <el-table-column
        prop="file"
        label="Fájl"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-image
            :src="getFileLogo(scope.row.file_extension)"
            fit="contain"
            style="width: 30px; height: 30px"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="file"
        label="Típus"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.file_extension }}
        </template>
      </el-table-column>
      <el-table-column
        prop="description"
        label="Leírás"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.description || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="file_size"
        label="Méret"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.file_size | fileSize }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="170"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <actions
            :file="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="fileFormType === 'add' ? 'Új fajl' : 'Fájl módosítás'"
      append-to-body
      :close-on-click-modal="false"
      width="450px"
      @close="onClose"
      :key="dialogKey"
    >
      <file-form
        ref="fileForm"
        :defaultFile="selectedFile"
        :formType="fileFormType"
        :files="files"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeFiles"
        >
          {{ fileFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Actions from './Actions';
  import FileForm from './Form';

  export default {
    components: { Actions, FileForm },
    props: ['files', 'showDialog', 'fileFormType'],
    data() {
      return {
        dialogKey: 0,
        selectedFile: {
          file: {}
        },
      };
    },
    methods: {
      onClose() {
        this.$refs.fileForm.$refs.fileForm.resetFields();
        this.$refs.fileForm.file = {
          file: {}
        };
        this.selectedFile = {
          file: {}
        };
        this.$refs.fileForm.fileList = [];
        this.$emit('closeDialog');
      },
      onCreate() {
        this.fileFormType = 'add';
        this.dialogKey++;
        this.$emit('openCreateDialog');
      },
      onUpdate(file) {
        this.selectedFile = Object.assign({}, file);
        this.$emit('openUpdateDialog');
      },
      onDelete(file) {
        const files = this.files.filter(a => ((a.id && a.id !== file.id) || a.key !== file.key));
        this.$emit('change', files);
        this.$emit('delete', file);
      },

      getFileLogo(type) {
        switch (type) {
          case 'pdf':
            return '/img/fileTypes/pdf.svg';
          case 'doc':
            return '/img/fileTypes/doc.svg';
          case 'docx':
            return '/img/fileTypes/doc.svg';
          case 'xls':
            return '/img/fileTypes/xls.svg';
          case 'xlsx':
            return '/img/fileTypes/xls.svg';
          case 'txt':
            return '/img/fileTypes/txt.svg';
          case 'zip':
            return '/img/fileTypes/zip.svg';
          case 'csv':
            return '/img/fileTypes/csv.svg';
          default:
            return '/img/fileTypes/file.svg';
        }
      },


      async storeFiles() {
        const file = JSON.parse(JSON.stringify(this.$refs.fileForm.file));
        const source = this.$refs.fileForm.source;
        file.source = source;
        if ((this.fileFormType === 'add' && file.file.path) || this.fileFormType === 'update') {
          this.$refs['fileForm'].$refs['fileForm'].validate(valid => {
            if (valid) {
              if (this.fileFormType === 'add') {
                this.$emit('add', file);
              } else {
                const files = this.files.map(a => {
                  if ((a.id && a.id === file.id) || (a.key && a.key === file.key)) {
                    return file;
                  } else {
                    return a;
                  }
                });
                this.$emit('change', files);
              }
              this.onClose();
            }
          });
        } else {
          this.$messageWrapper.warning('Fájl feltöltese kötelező');
        }
      },
      openFile(file) {
        if (file.id) {
          window.open(file.path);
        } else {
          this.$messageWrapper.warning('Fájl még nincs feltöltve');
        }

      }
    }
  };
</script>
